import axios from '@/requests';
import { Camera } from '@/store/modules/camera/types';

export const cameraAPI = {
    async getCameraListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<Camera[]>('/Camera/getCameraListByUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getCameraListByUidAndTime(projId: string, uid: string, time: string) {
        try {
            const res = await axios.get<Camera[]>('/Camera/getCameraListByUidAndTime', { "projId": projId, "uid": uid, "time": time });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
}